import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import Logo from '../assets/mainlogo.png';

function Store() {
  const [screenHeight, setScreenHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isLaptopMessageShown, setIsLaptopMessageShown] = useState(false);

  const gtmId = 'GTM-T4QRDGLB';
  const initializeTagManager = () => {
    TagManager.initialize({ gtmId });
  };

  useEffect(() => {
    // Function to update screen height
    const updateHeight = () => {
      setScreenHeight(window.innerHeight);
      console.log(screenHeight);
    };

    // Initial update of screen height
    updateHeight();

    // Event listener for window resizing
    window.addEventListener('resize', updateHeight);

    // Determine if user is on mobile
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    setIsMobile(/android|iphone|ipad|ipod/i.test(userAgent));

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [screenHeight]);

  useEffect(() => {
    initializeTagManager();
    // Function to determine platform and redirect accordingly
    const redirectBasedOnPlatform = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isAndroid = /android/i.test(userAgent);

      if (!isIOS && !isAndroid) {
        // Display message for users on laptops or desktops
        setIsLaptopMessageShown(true);
      } else {
        const schemeURL = 'TheBooker://store/123'; // Custom URL scheme
        const appStoreURL =
          'https://apps.apple.com/cl/app/thebooker/id6503916811?l=en-GB'; // Apple App Store URL
        const playStoreURL =
          'https://play.google.com/store/apps/details?id=com.thebooker'; // Google Play Store URL

        // Attempt to redirect to the custom URL scheme (app) if on mobile
        window.location.href = schemeURL;

        // Setup a timeout to redirect to the store if the app is not installed
        const timeout = setTimeout(() => {
          if (isIOS) {
            window.location.href = appStoreURL;
          } else if (isAndroid) {
            window.location.href = playStoreURL;
          }
        }, 200);

        // Listen for visibility change or focus events to clear timeout
        const handleVisibilityChange = () => {
          clearTimeout(timeout);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup function to remove event listener
        return () => {
          document.removeEventListener(
            'visibilitychange',
            handleVisibilityChange
          );
        };
      }
    };

    // Call the redirect function when component mounts
    redirectBasedOnPlatform();
  }, []);

  const handleRetry = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  return (
    <div className='storePage min-h-screen w-full flex flex-col items-center justify-center'>
      {!isMobile && isLaptopMessageShown ? (
        <div className='text-center text-white'>
          <div className='flex justify-center mb-6'>
            <img
              alt='TheBooker Logo'
              src={Logo}
              className='w-48 h-48 object-contain'
            />
          </div>
          <h2 className='text-2xl font-semibold mb-2'>
            Please Open This Link on Your Mobile Device
          </h2>
          <p>This link is designed to open our mobile app</p>
        </div>
      ) : (
        isMobile && (
          <div className='text-center'>
            <div className='flex justify-center mb-6'>
              <img
                alt='TheBooker Logo'
                src={Logo}
                className='w-48 h-48 object-contain'
              />
            </div>
            <p className='text-white mb-4'>Opening TheBooker App...</p>
            <p className='text-white'>
              If nothing happens,{' '}
              <button onClick={handleRetry} className='text-white underline '>
                Click Here!
              </button>
            </p>
          </div>
        )
      )}
    </div>
  );
}

export default Store;
